import React, { useContext, useMemo } from 'react';
import { LoadingOverlay, Skeleton } from '@mantine/core';
import { ContestStatus, type FullContest } from '@betterpool/api-types/contests-service';
import useTranslation from 'next-translate/useTranslation';
import { useIsMutating } from '@tanstack/react-query';

import { UserContext } from '~/components/providers/UserProvider';
import dt from '~/testing';
import { ButtonLink } from '~/domains/design-system/Button';

import { Routes } from '~/domains/common/constants/routes';

type ViewContestButtonProps = {
  className?: string;
  contest: FullContest;
};

function ViewContestButton({ className, contest }: ViewContestButtonProps) {
  const { t } = useTranslation('contest');
  const { user } = useContext(UserContext);
  const entriesPath = useMemo(() => {
    if (contest.status !== ContestStatus.SCHEDULED) {
      return Routes.gamecenterStandingsOverall(contest.id);
    }
    return Routes.gamecenterEntriesOverall(contest.id);
  }, [contest.status, contest.id]);

  const isLoading = Boolean(useIsMutating(['createOrJoinEntry']));

  return (
    <Skeleton visible={user && isLoading} h={40} className={className}>
      <LoadingOverlay visible={user && isLoading} loaderProps={{ size: 'sm' }} />
      <ButtonLink
        variant="primary-fill"
        size="medium"
        data-test-id={dt.contestDetail.page.header.actions.view}
        href={entriesPath}
      >
        {t('detail.header.actions.view')}
      </ButtonLink>
    </Skeleton>
  );
}

export default ViewContestButton;
